<template>
  <el-dialog
    :title="`库位库存数据（${config.binNo}）`"
    :visible.sync="visible"
    width="960px"
    append-to-body
    @closed="handleClosed">
    <!-- <div class="search-form">
      <el-input
        v-model="config.siName"
        clearable=""
        placeholder="请输入打印机名称"
        style="width: 200px;">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div> -->
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        fixed="left"
        label="委托单号"
        min-width="160"
        prop="appraisalNo"></el-table-column>
      <el-table-column
        label="外部订单号"
        prop="yhbBizOrderId"
        width="170"></el-table-column>
      <el-table-column
        label="品名"
        min-width="180"
        prop="spuName"></el-table-column>
      <el-table-column
        label="支付状态"
        min-width="80"
        prop="settlementStatus">
        <template slot-scope="{ row }">{{ settlementStatusMap[row.settlementStatus] }}</template>
      </el-table-column>
      <el-table-column
        label="当前状态"
        min-width="80">
        <template slot-scope="{ row }">{{ row.status | orderStatusName() }}</template>
      </el-table-column>
      <el-table-column
        label="入库时间"
        width="150">
        <template slot-scope="scope">{{ scope.row.inboundTime | dateformat() }}</template>
      </el-table-column>
      <el-table-column
        label="鉴定结果"
        width="90">
        <template slot-scope="{ row }">{{ row.appraisalResult | appraisalResultName() }}</template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="100">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            @click="reportingloss(row)">报损</el-button>
          <el-button
            type="text"
            @click="viewDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"></el-pagination>
    <div slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
    </div>
    <appraisal-detail-drawer ref="detail" />
  </el-dialog>
</template>
<script>
import Wms from '@/service/wms'
import AppraisalDetailDrawer from '@/pages/appraisal/order/appraisal-detail-drawer.vue'
export default {
  name: 'BinsetInventoryModal',
  components: { AppraisalDetailDrawer },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: { pageNum: 1, pageSize: 10, binId: null, binNo: '' },
      total: 0,
      settlementStatusMap: { 0: '未结算', 1: '未结算', 2: '已结算', 9: '坏账', 15: '无需结算' }
    }
  },
  methods: {
    viewDetail(row) {
      this.$refs.detail.fetch({ id: row.id })
    },
    reportingloss(row) {
      this.$prompt('请输入报损原因', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /.+/, inputErrorMessage: '请输入报损原因',
        beforeClose: (action, instance, done) => {
          if (action === 'cancel' || action === 'close') {
            done()
          } else {
            this.loading = true
            Wms.reportingloss({ lossReason: instance.inputValue, id: row.id })
              .then(res => {
                this.loading = false
                const { result, message } = res.data
                if ([0].includes(result)) {
                  this.$message.success('报损成功')
                  done()
                  this.fetchList()
                } else {
                  this.$message.error(message)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error(err.message)
              })
          }
        }
      })
    },
    handleClosed() {
      this.config.pageNum = 1
      this.list = []
      this.total = 0
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Wms.getappraisalorders({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options = {}) {
      this.config = { ...this.config, ...options }
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus">
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
